<template>
  <div class="p-3 pt-md-4 pt-5 text-white">
    <v-container fluid>
      <v-row>
        <v-col class="p-0">
          <p class="text-white font-weight-bold">
            Olá! Você está prestar a iniciar o desafio deste ciclo de estudos. O desafio consiste em uma avaliação com questões de todos os
            módulos que você estudou neste ciclo. Antes de iniciar, leia estas informações importantes:
          </p>
          <ol class="pl-3 mb-md-3 mb-4">
            <li class="text-white pb-2">
              O tempo total do desafio depende do número de módulos do seu ciclo. Caso sejam 3 módulos, você terá 90 minutos. Caso sejam 2 módulos, você terá 60 minutos. Caso sejam 4 módulos, você terá 120 minutos.
            </li>
            <li class="text-white pb-2">
              Você não poderá pausar o cronômetro e voltar ao desafio depois. Por isso, certifique-se que este é o momento ideal para realizar sua avaliação;
            </li>
            <li class="text-white pb-2">
              Caso tenha algum problema com sua rede ou com a plataforma durante a realização da prova, comunique à sua escola o mais rápido possível;
            </li>
            <li class="text-white pb-2">
              Você responderá questões apenas dos assuntos dos módulos estudados. Elas estarão agrupadas por área do conhecimento, assim como o ENEM;
            </li>
            <li class="text-white pb-2">
              Você deverá responder TODAS as questões da prova antes de finalizar;
            </li>
            <li class="text-white pb-2">
              O seu resultado completo poderá ser visualizado ou ao final do desafio ou ao final do ciclo, de acordo com a configuração definida pela sua escola.
            </li>
          </ol>
          <p class="font-weight-bold h4 text-white">
            Boa prova!
          </p>
          <div
            id="confirm-button-container"
            class="d-flex justify-content-md-end flex-wrap"
          >
            <v-btn
              rounded
              outlined
              class="text-white mt-3 border-challenge"
              @click="$store.commit('SHOW_MODAL_CHALLENGE', false)"
            >
              <i class="fas fa-solid fa-reply mr-1" /> Quero iniciar depois
            </v-btn>
            <v-btn
              color="challenge"
              class="ml-0 ml-md-2 ml-lg-2 font-weight-bold mt-3"
              rounded
              @click="start()"
            >
              Iniciar Desafio <i class="fas fa-play-circle ml-1" />
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>

import { mapActions, mapState } from 'vuex';

export default {
  computed:{
    ...mapState({
      challenge : state => state.challenge.current,
    })
  },
  methods: {
    ...mapActions(['startChallenge']),
    start() {
      this.startChallenge({ id: this.challenge.id })
    },
  }
}
</script>

<style lang="scss" scoped>

.challenge{
  background-color: #f74a4b !important;
}
  @media screen and (max-width: 766px) {
    #confirm-button-container button{
      width: 100%;
    }
  }
</style>

